import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Reveal";

const services = [
  {
    tag: "Admin Services",
    title: "AI-Powered Back-Office Administration",
    body: "Fast, accurate processing of client documents, policy notes, and provider statements using AI — freeing your core team from manual admin while keeping compliance data in check.",
    points: [
      "Automated data extraction & LOA tracking",
      "Intelligent client onboarding & compliance checks",
      "Platform submissions & annual review prep",
      "CRM upkeep (IO, Xplan, etc.)",
    ],
    img: "https://images.unsplash.com/photo-1772178138141-759474fe7457?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBvZmZzaG9yZSUyMHRlYW0lMjBidXNpbmVzcyUyMGNhbG18ZW58MHx8fHwxNzg0NzM3NzA0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Paraplanning Services",
    title: "AI-Enhanced Precision Paraplanning",
    body: "AI-assisted suitability drafting and research paired with rigorous human oversight — every report reviewed, refined, and signed off by qualified paraplanners to support your firm's FCA compliance requirements.",
    points: [
      "AI-assisted suitability drafting",
      "Smart research & cash flow analytics",
      "Complex pension, investment & tax analysis",
      "Rigorous human oversight & sign-off",
    ],
    img: "https://images.pexels.com/photos/19553078/pexels-photo-19553078.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const Services = () => (
  <section id="services" className="py-24 md:py-36 bg-parchment-dark relative z-10 border-y border-petrol/15" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <span className="font-sans text-xs uppercase tracking-[0.28em] text-verdigris">
        What We Offer
      </span>
      <FadeUp>
        <h2 className="font-serif text-petrol text-4xl md:text-6xl tracking-tight max-w-3xl mt-8 leading-[1.02]">
          Tailored back-office & paraplanning solutions.
        </h2>
        <p className="font-sans text-petrol/70 text-lg max-w-2xl mt-6 leading-relaxed">
          Direct, plain-language support designed for the way UK practices
          actually work — no jargon, no bloat.
        </p>
      </FadeUp>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 mt-16 md:mt-24">
        {services.map((s, i) => (
          <FadeUp
            key={s.tag}
            delay={i * 0.14}
            className="group bg-parchment border border-petrol/20 flex flex-col"
            data-testid={`service-card-${i + 1}`}
          >
            <div className="overflow-hidden h-56 md:h-64 border-b border-petrol/15">
              <img
                src={s.img}
                alt={s.tag}
                className="h-full w-full object-cover grayscale-[35%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
              />
            </div>
            <div className="p-8 md:p-12 flex flex-col flex-1">
              <div className="flex items-center justify-between mb-6">
                <span className="font-sans text-xs uppercase tracking-[0.2em] text-verdigris">
                  {s.tag}
                </span>
                <ArrowUpRight className="text-petrol/40 group-hover:text-petrol group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" size={22} />
              </div>
              <h3 className="font-serif text-3xl md:text-4xl text-petrol leading-tight mb-5">
                {s.title}
              </h3>
              <p className="font-sans text-petrol/70 leading-relaxed mb-8">{s.body}</p>
              <ul className="mt-auto grid grid-cols-2 gap-x-6 gap-y-3 border-t border-petrol/15 pt-6">
                {s.points.map((p) => (
                  <li key={p} className="flex items-center gap-2.5 font-sans text-sm text-petrol/80">
                    <span className="h-1.5 w-1.5 bg-verdigris rounded-full shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
